import React, {Component} from 'react';
import {Modal, Button} from 'antd';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: props.visible
        };
    }

    handleCancel() {
        this.setState({
            visible: false
        });

        this.props.handleCancel();
    }

    handleOk() {
        this.setState({
            visible: false
        });

        this.props.handleSubmit();
    }

    componentWillReceiveProps(nextProps) {
        const visible = nextProps.visible;
        this.setState({
            visible
        })
    }

    render() {
        const { children, title, width, styleName, okText, cancelText, style ,noFooter, bodyStyle } = this.props;
        return (
            <Modal 
            title={ title } 
            destroyOnClose={this.props.destroyOnClose || false}
            wrapClassName={styleName || "root-modal"}
            style={style}
            maskClosable={false}
            visible={this.state.visible}
            bodyStyle={bodyStyle}
            width={width || "830px"}
            okText={okText || "确定"}
            cancelText={cancelText || "取消"}
            onOk={this.handleOk.bind(this)}
            onCancel={() => {
                this.handleCancel();
            }}
            footer={noFooter ? false : [
                <Button 
                key="back"
                onClick={() => {
                    this.handleCancel();
                }}>{cancelText || "取消"}</Button>,
                <Button key="submit" type="primary" 
                loading={this.props.loading}
                onClick={this.handleOk.bind(this)}
                >{okText || "确定"}</Button>,
            ]}>
                {children}
            </Modal>
        )
    }
}